import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CookieManagerService, ErrorManagerService, HttpClientService } from '../../../shared/';
import { ApiEndpoints, StatisticsTypes } from '../../constant';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';


@Component({
  selector: 'app-overall',
  templateUrl: './overall.component.html',
  styleUrls: ['./overall.component.css', './../statistics.component.css']
})
export class OverallComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  public statisticsType: string = StatisticsTypes.overall.text;
  public statisticsData: any = [];
  public subjectArray: any = [];
  public currentSubject: string;
  public selectedSubjectProgress;
  public selectedPapersSubjects;
  public barChartType: string = 'bar';
  public barChartLegend: boolean = false;

  public apiRequstWaiter: boolean = true;

  public backgroundColor = [];
  public barChartData: any[] = [{ data: [], label: 'Marks Average', backgroundColor: [] }];
  public barChartLabels: string[] = [];
  public barChartOptions: any = {
    animation: {
      duration: 1,
      onComplete: function () {
        var chartInstance = this.chart,
          ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        ctx.fillStyle = "rgba(0, 0, 0, 1)";
        ctx.textBaseline = 'bottom';

        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data + "%", bar._model.x, bar._model.y - 5);

          });
        });
      }
    },
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          max: 120
        }
      }]
    },
    showTooltips: true
  };

  constructor(
    private trans: TranslateService,
    private httpClientService: HttpClientService,
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.getStatisticDetails();
    window.scrollTo(0, 0);
  }

  /**
   * api call to get overoll details
   */
  getStatisticDetails() {
    // get the overall detils
    this.apiRequstWaiter = false;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getStatisticsOverAll, { [ApiEndpoints.paperSetType]: this.statisticsType, }), null).subscribe(
      res => {
        // KinderJoy
        
        //setTimeout(() => {
        this.apiRequstWaiter = true;
        if (res.statistics.length == 0) { //if no data hide the view
        } else {
          this.initChart(res, this.initChartData(res.statistics));
          this.getFirstSubject(res.statistics);
        }
      //}, 3000);
      });
  }

  /**
   * customize the chart details
   */
  initChartData(res) {
    let label = [];
    let backgroundColor = [];
    let data = [];

    // freach the data set
    res.forEach(statistic => {
      label.push(statistic.category.category);// push to lable array
      backgroundColor.push(StatisticsTypes.overall.chartColor);// push to background color array
      data.push(statistic.percentageMark);// push to dta array
      this.subjectArray[statistic.category.category] = statistic.category._id // push to subject array
    });

    return { label, backgroundColor, data };

  }

  /**
   * update chart details
   * @param res 
   * @param chartData 
   */
  initChart(res, chartData) {
    // assigh to cart value 
    this.backgroundColor = [];
    this.barChartData = [{
      data: chartData.data, label: 'Marks Average', backgroundColor: chartData.backgroundColor
    }];
    this.barChartLabels = chartData.label;

    // update the chart
    if (this.chart && this.chart.chart && this.chart.chart.config) {
      this.chart.chart.config.data.labels = chartData.label;
      this.chart.chart.config.data.datasets = this.barChartData;

      this.chart.chart.update();
    }
  }

  /**
   * get subject details of first one
   * @param statisticsData 
   */
  getFirstSubject(statisticsData) {
    // get all subjects of selected paper
    this.selectedPapersSubjects = statisticsData;
    // to get skills details to first subject
    let statistics = statisticsData[0]
    let id = statistics.category._id;
    this.currentSubject = statistics.category.category;
    this.setSubjectProgress(id);
  }

  /**
   * @param column column label
   * get the subject skill details
   */
  setSubjectProgress(column) {
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getStatisticsOverAllSubjectByPaperType, { [ApiEndpoints.paperSetType]: this.statisticsType, [ApiEndpoints.subjectCategoryid]: column }), null).subscribe(
      res => {
        if (res && res.statistics.length != 0) {
          this.selectedSubjectProgress = res.statistics;
        }
      });

  }

  /**
   * @param e click event
   * load the skill details according to clicked subject
   */
  public chartClicked(e: any): void {
    let label = ((e.active[0] || {})._model || {}).label;
    if (label) {
      let id = this.subjectArray[label]
      this.currentSubject = label;

      this.setSubjectProgress(id);
    }
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  /**
  * subject selection
  */
  changeSubject(subject) {
    let id = subject.category._id;
    this.currentSubject = subject.category.category;
    this.setSubjectProgress(id);
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/statistics/overall/overall.component.ts